import "./composition-api.js";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { i18n } from "./i18n";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import "./assets/css/app.dev.css";

Vue.config.productionTip = false;

if (config.VUE_APP_SENTRY_DSN != undefined) {
  Sentry.init({
    dsn: config.VUE_APP_SENTRY_DSN,
    environment: config.VUE_APP_ENVIRONMENT,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
  });
}

new Vue({
  router,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
